<template>
  <div
    class="reporting-registry"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <v-tabs
      v-model="activeTab"
      dense
    >
      <v-tab>
        {{ issuedLabel }}
      </v-tab>
      <v-tab>
        {{ scheduledLabel }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <BaseDashboardTable
          :columns="issuedColumns"
          :rows="issuedRows"
          :item-key="issuedItemKey"
          :hide-default-footer="false"
          :server-items-length="issuedServerItemsLength"
          :options="issuedOptions"
          @detail="$emit('row-detail', $event)"
          @action="$emit('action', $event)"
          @update:options="$emit('update:options', { instance: issuedInstance, options: $event })"
        />
      </v-tab-item>
      <v-tab-item>
        <BaseDashboardTable
          :columns="scheduledColumns"
          :rows="scheduledRows"
          :item-key="scheduledItemKey"
          :hide-default-footer="false"
          :server-items-length="scheduledServerItemsLength"
          :options="scheduledOptions"
          @detail="$emit('row-detail', $event)"
          @action="$emit('action', $event)"
          @update:options="$emit('update:options', { instance: scheduledInstance, options: $event })"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'

export default {
  name: 'BaseReportingRegistry',
  components: { BaseDashboardTable },
  mixins: [DashboardHighlightOnRender],
  props: {
    issuedLabel: {
      type: String,
      required: true
    },
    scheduledLabel: {
      type: String,
      required: true
    },
    issuedColumns: {
      type: Array,
      required: true
    },
    issuedRows: {
      type: Array,
      required: true
    },
    scheduledColumns: {
      type: Array,
      required: true
    },
    scheduledRows: {
      type: Array,
      required: true
    },
    issuedItemKey: {
      type: String,
      required: false,
      default: undefined
    },
    scheduledItemKey: {
      type: String,
      required: false,
      default: undefined
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    issuedServerItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    scheduledServerItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    issuedOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    scheduledOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    initialTab: {
      type: String,
      required: false,
      default: 'issued',
      validator: (value) => ['issued', 'scheduled'].includes(value)
    }
  },
  data() {
    return {
      activeTab: this.initialTab === 'scheduled' ? 1 : 0
    }
  },
  computed: {
    issuedInstance() {
      return this.instance ? `${this.instance}-issued` : ''
    },
    scheduledInstance() {
      return this.instance ? `${this.instance}-scheduled` : ''
    }
  }
}
</script>

<style lang="scss">
.reporting-registry {
  .v-tabs > .v-tabs-bar {
    background-color: transparent !important;
  }

  .v-tabs-items {
    background: transparent;
    padding-top: 12px;
  }
}
</style>
